<template>
  <div>
    <swiper class="cart__packs" :loop="false" :currentPage="currentPage"
            @slider-move="slideMove"
            @slide-touch-end="onSlideTouchEnd"
            @slide-change-page="onSlideChangePage">
      <CartPack class="infinity-swipe-item" v-for="(pack, index) in cart.packs" :key="'pack_'+index"
                :pack="pack" :cart="cart" @remove="remove(pack)"></CartPack>
    </swiper>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import CartPack from './Pack.vue'
  import InfinitySwipe from '../InfinitySwipe.vue'
  export default {
    name: 'CartCart',
    components: {
      CartPack,
      swiper: InfinitySwipe,
    },
    props: ['cart'],
    data(){
      return {
        selectedPack: null,
        currentPage: 1
      }
    },
    created () {
      this.selectedPack = this.cart.packs[0];
      this.$store.commit('disableAfterActiveTab', this.$store.state.product_tab.buttons.length); // 商品修正した時に全画面使えるようにする
    },
    methods: {
      setPage: function (page) {
        this.currentPage = page;
        this.selectedPack = this.cart.packs[page - 1];
      },
      onSlideTouchEnd: function(page, time){
        this.touch_time = time;
        this.onSlideChangePage(page);
      },
      onSlideChangePage: function (page) {
        this.setPage(page);
      },
      slideMove: function (translate, delta) {
        let item_width = window.innerWidth;
        let page = this.currentPage;
        if (delta < 0) {
          page = Math.floor(translate / item_width) * -1 + 1;
        } else {
          page = Math.floor(translate / item_width) * -1;
        }
        if (page <= 0) page = 1;
        if (page > this.cart.packs.length) page = this.cart.packs.length + 1;
        if (this.cart.packs[page - 1] !== undefined) {
          this.setPage(page);
        }
      },
      remove(pack) {
        this.$store.commit('removeCartPack', this.cart, pack);
      }
    },
    computed:{
      ...mapGetters([
        'designPrice',
        'basePrice',
        'totalPrice',
        'cartStockTotalPrice',
      ])
    }
  }
</script>
<style lang="scss" scoped>
  .infinity-swipe-item {
    width: 100%;
  }
</style>
